import React, { useContext, useEffect, useState, startTransition } from 'react';
import { Navigate } from 'react-router';
import RenderSpinner from 'src/components/Spinner';
import { UserContext } from 'src/UserContextProvider';

const requirePermission = requiredPermission => WrappedComponent => {
  return props => {
    const { userRole } = useContext(UserContext);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      if (userRole) {
        startTransition(() => {
          setLoading(false);
        });
      }
    }, [userRole]);

    if (loading) return <RenderSpinner />;

    const userPermissions = userRole?.roleroutepermission?.map(permission => permission.route);

    if (!userRole || (requiredPermission && !userPermissions.includes(requiredPermission))) {
      return <Navigate to='/access-denied' replace />;
    }

    return <WrappedComponent {...props} />;
  };
};

const PrivateRoute = ({ permission, component }) => {
  const WrappedComponent = requirePermission(permission)(component);
  return <WrappedComponent />;
};

export default PrivateRoute;
